export default __webpack_public_path__ + "static/media/left-chevron.f51d0224.svg";